<div class="row justify-content-center g-0">
  <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6">
    @if(processing()) {
      <h2 class="text-center">
        <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
      </h2>
    }
    
    @if(alert) {
    <ngb-alert [type]="alert.type">{{ alert.message }}</ngb-alert>
    }

    @if(!processing() && pool){
      <div class="d-flex justify-content-between my-3">
        <h2 class="text-truncate">
          <fa-icon [icon]=faUsers></fa-icon> speler selecteren
        </h2>       
        <button (click)="myNavigation.back()" type="button" class="btn btn-outline-dark">
          <fa-icon [icon]=faLevelUpAlt [rotate]="270"></fa-icon>
          <span class="ms-1 d-none d-md-inline"> terug</span>
        </button>      
      </div>   
       
      <div formGroup="form" class="d-flex justify-content-end mt-2 mb-0 me-2">
        <input #orderByPointsInput type="checkbox" class="form-check-input"
          (change)="updateOrderByPoints(orderByPointsInput.checked)"
          id="orderByPoints" formControlName="orderByPoints">          
        <label class="form-check-label px-2" for="orderByPoints">meeste punten eerst</label>
      </div>

      @if(assembleFormation && selectableTeams.length > 0) {
        <div class="d-flex justify-content-center">
          <app-pool-player-choose class="w-100" [competitionConfig]="pool.getCompetitionConfig()"
            [viewPeriod]="pool.getCreateAndJoinPeriod()" [viewPeriodType]="AssembleViewPeriod"
            [alreadyChosenPersons]="alreadyChosenPersons"
            [alreadyChosenTeams]="alreadyChosenTeams" [selectableLines]="selectableLines" 
            [filter]="choosePlayersFilter" [selectableTeams]="selectableTeams"
            [orderByPoints]="orderByPoints"
            (selectS11Player)="editPlace(pool,$event)"
            (linkToS11Player)="linkToPlayer(pool,$event)" (filterUpdate)="updateState($event)">
          </app-pool-player-choose>
        </div>
      }
    }
  </div>
</div>